import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

class UtilitiesDashboardApp {
  constructor(htmlNode, initialState) {
    createRoot(htmlNode).render(<App {...initialState} />);
  }
}

export default UtilitiesDashboardApp;
